import React, { useState, useRef, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Common.css";

const images = [
  "/Images/Images23.svg",
  "/Images/Gallry12.jpg",
  "/Images/Image3.svg",
  "/Images/Image4.svg",
  "/Images/Image5.svg",
  "/Images/Image6.svg",
  "/Images/Image7.svg",
  "/Images/Image8.svg",
  "/Images/Gallary16.jpg",
  "/Images/Gallary17.jpg",
  "/Images/Gallary18.jpg",
  "/Images/Image1.svg",
  "/Images/Image101.jpg",
  "/Images/Image102.jpg",
  "/Images/Image103.jpg",
  "/Images/Image104.jpg",
  "/Images/Image105.jpg",
  "/Images/Image106.jpg",
  "/Images/Image107.jpg",
  "/Images/Image108.jpg",
  "/Images/Image109.jpg",
  "/Images/Image110.jpg",
  "/Images/Image111.jpg",
  "/Images/Image112.jpg",
  "/Images/Image113.jpg",
  "/Images/Image114.jpg",
  "/Images/Image115.jpg",
  "/Images/Image116.jpeg",
  "/Images/Image117.jpeg",
  "/Images/Image118.jpeg",
  "/Images/Image119.jpeg",
  "/Images/Image120.jpeg",
  "/Images/Image121.jpeg",
  "/Images/Image122.jpeg",
  "/Images/Image123.jpeg",
  "/Images/Image124.jpeg",
  "/Images/Image125.jpeg",
];

const videos = [
  {
    title: "Anemia Mukt Bharat – Awareness Drive",
    thumbnail: "/Images/Thumbnail1.png",
    src: "/Images/Videos/RBSKMOcounselling.mp4",
  },
  {
    title: "Iron Supplementation Programme",
    thumbnail: "/Images/Thumbnail2.png",
    src: "/Images/Videos/RBSK_taking_training_on_AMB.mp4",
  },
  {
    title: "Field Activities & Training Sessions",
    thumbnail: "/Images/Thumbnail3.png",
    src: "/Images/Videos/UT_CHANDIGARHAMB_VIDEO.mp4",
  },
  {
    title: "Field Activities & Training Sessions",
    thumbnail: "/Images/Videos/Image2.jpg",
    src: "/Images/Videos/IVIS_administration_Bihar.mp4",
  },
  {
    title: "Field Activities & Training Sessions",
    thumbnail: "/Images/Videos/Image2.jpg",
    src: "/Images/Videos/SCHOOL_HD.mp4Odisha.mp4",
  },
  {
    title: "Field Activities & Training Sessions",
    thumbnail: "/Images/Videos/Image2.jpg",
    src: "/Images/Videos/TVC-Amlan_Bhanda_Baba,60sec_NEW.mov",
  },
  {
    title: "Field Activities & Training Sessions",
    thumbnail: "/Images/Videos/Image2.jpg",
    src: "/Images/Videos/RBSK_HB_screening_Telangana_(2).mp4",
  },
  {
    title: "Field Activities & Training Sessions",
    thumbnail: "/Images/Videos/Image2.jpg",
    src: "/Images/Videos/RBSK_Hb_screening_Telangana.mp4",
  },
];

function MediaGallery() {
  // ---- Image modal ----
  const [show, setShow] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const handleOpen = (index) => { setSelectedIndex(index); setShow(true); };
  const handleClose = () => setShow(false);

  // ---- Video: which video is in the large card ----
  const [activeVideo, setActiveVideo] = useState(0);

  // ---- Video modal ----
  const [showVideo, setShowVideo] = useState(false);
  const [modalVideo, setModalVideo] = useState(0);
  const videoRef = useRef(null);

  // The two videos shown in small cards (all except active)
  const otherVideos = videos.map((_, i) => i).filter((i) => i !== activeVideo);

  // Large card arrows
  const prevActive = (e) => {
    e.stopPropagation();
    setActiveVideo((prev) => (prev === 0 ? videos.length - 1 : prev - 1));
  };
  const nextActive = (e) => {
    e.stopPropagation();
    setActiveVideo((prev) => (prev === videos.length - 1 ? 0 : prev + 1));
  };

  // Video modal controls
  const openVideoModal = (index) => { setModalVideo(index); setShowVideo(true); };
  const closeVideoModal = () => {
    if (videoRef.current) { videoRef.current.pause(); videoRef.current.src = ""; }
    setShowVideo(false);
  };
  const modalNext = () =>
    setModalVideo((prev) => (prev === videos.length - 1 ? 0 : prev + 1));
  const modalPrev = () =>
    setModalVideo((prev) => (prev === 0 ? videos.length - 1 : prev - 1));

  // Auto-play when modal video index changes
  useEffect(() => {
    if (showVideo && videoRef.current) {
      videoRef.current.load();
      videoRef.current.play().catch(() => { });
    }
  }, [showVideo, modalVideo]);

  return (
    <>
      <section className="gallery-section">
        <div className="container">
          <div className="text-center">
            <span className="gallery-badge">PROGRAMMES IN ACTION</span>
            <h2 className="mt-3 heading">Video & Media Gallery</h2>
            <p className="sub-heading">
              Glimpses from ground-level activities, training sessions and
              outreach programmes
            </p>
          </div>

          <div className="gallery-grid">

            {/* ── item1: LARGE VIDEO CARD (col 1-2, row 1-2) ── */}
            <div
              className="gallery-item item1 video-thumb"
              onClick={() => openVideoModal(activeVideo)}
            >
              <img
                src={videos[activeVideo].thumbnail}
                alt={videos[activeVideo].title}
              />
              <div className="video-play-overlay">
                <div className="video-play-btn">
                  <i className="bi bi-play-fill"></i>
                </div>
              </div>
              <button className="video-arrow video-arrow--left" onClick={prevActive}>
                <i className="bi bi-chevron-left"></i>
              </button>
              <button className="video-arrow video-arrow--right" onClick={nextActive}>
                <i className="bi bi-chevron-right"></i>
              </button>
            </div>

            {/* ── Right-side images: UNCHANGED ── */}
            <div className="gallery-item item2" onClick={() => handleOpen(1)}>
              <img src={images[1]} alt="" />
            </div>

            <div className="gallery-item item3" onClick={() => handleOpen(2)}>
              <img src={images[2]} alt="" />
            </div>

            <div className="gallery-item item4" onClick={() => handleOpen(3)}>
              <img src={images[3]} alt="" />
            </div>

            <div className="gallery-item item5" onClick={() => handleOpen(4)}>
              <img src={images[4]} alt="" />
            </div>

            {/* ── item6 (row 3 col 1): SMALL VIDEO CARD 1 ── */}
            <div
              className="gallery-item item6 video-thumb"
              onClick={() => openVideoModal(otherVideos[0])}
            >
              <img
                src={videos[otherVideos[0]].thumbnail}
                alt={videos[otherVideos[0]].title}
              />
              <div className="video-play-overlay">
                <div className="video-play-btn video-play-btn--sm">
                  <i className="bi bi-play-fill"></i>
                </div>
              </div>
            </div>

            {/* ── item7 (row 3 col 2): SMALL VIDEO CARD 2 ── */}
            <div
              className="gallery-item item7 video-thumb"
              onClick={() => openVideoModal(otherVideos[1])}
            >
              <img
                src={videos[otherVideos[1]].thumbnail}
                alt={videos[otherVideos[1]].title}
              />
              <div className="video-play-overlay">
                <div className="video-play-btn video-play-btn--sm">
                  <i className="bi bi-play-fill"></i>
                </div>
              </div>
            </div>

            {/* ── Bottom-right images: UNCHANGED ── */}
            <div className="gallery-item item8" onClick={() => handleOpen(7)}>
              <img src={images[7]} alt="" />
            </div>

            <div className="gallery-item item6" onClick={() => handleOpen(5)}>
              <img src={images[5]} alt="" />
            </div>

          </div>
        </div>
      </section>

      {/* ── Image Modal (unchanged) ── */}
      <Modal show={show} onHide={handleClose} centered size="xl">
        <Modal.Header closeButton />
        <Modal.Body className="p-0">
          <img src={images[selectedIndex]} alt="" className="popup-image" />
          <button className="modal-nav-btn left" onClick={() => setSelectedIndex(prev => (prev === 0 ? images.length - 1 : prev - 1))}>
            <i className="bi bi-chevron-left" />
          </button>
          <button className="modal-nav-btn right" onClick={() => setSelectedIndex(prev => (prev === images.length - 1 ? 0 : prev + 1))}>
            <i className="bi bi-chevron-right" />
          </button>
        </Modal.Body>
      </Modal>

      {/* ── Video Modal ── */}
      <Modal show={showVideo} onHide={closeVideoModal} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "16px", fontWeight: 600 }}>
            {videos[modalVideo].title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <video
            ref={videoRef}
            controls
            autoPlay
            className="modal-video"
            key={modalVideo}
          >
            <source src={videos[modalVideo].src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="video-modal-nav">
            <button className="video-modal-btn" onClick={modalPrev}>
              <i className="bi bi-chevron-left"></i> Previous
            </button>
            <span className="video-modal-counter">
              {modalVideo + 1} / {videos.length}
            </span>
            <button className="video-modal-btn" onClick={modalNext}>
              Next <i className="bi bi-chevron-right"></i>
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default MediaGallery;
